module.exports = __webpack_public_path__ + "img/summary.3730cf0e.svg";